<template>
  <div>
    <div class="thanks">
      <div class="possible">
        <h2>T H A N K Y O U </h2>
        <p>we will contact you as soon as possible.</p>
        <button class="demo" @click="demo">BACK TO HOMEPAGE</button>
      </div>
    </div>
    <div class="thanksPhone">
      <div class="possiblePhone">
        <h2>T H A N K Y O U </h2>
        <p>we will contact you as soon as possible.</p>
        <button class="demo" @click="demo">BACK TO HOMEPAGE</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    demo() {
      this.$router.push('/');
    },
  }
}
</script>

<style  lang="scss">
.thanks {
  display: block;
  height: 380px;
  // overflow-y: auto;
  background: url(../assets/Thankpc.png) no-repeat;
  background-size: 100%;
  display: flex;
  // margin: auto;
  justify-content: center;
  align-items: center;

  // position: relative;
  .possible {
    text-align: center;
    width: 200px;
    height: 100px;

    h2 {
      font-size: 20px;
      color: #444198;

    }

    p {
      color: #444198;
      font-size: 8px;
    }
    .demo {
    margin-top: 10px;
    width: 80px;
    height: 25px;
    background-color: #32c89b;
    text-align: center;
    color: #fff;
    border-radius: 20px;
    border: none;
  }

  }
}

.thanksPhone {
  display: none;
  height: 1000px;
  width: 100%;
  background: url(../assets/Thankphone.png) no-repeat;
  background-size: 100%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // margin-top: 100px;

  .possiblePhone {
    width: 300px;
    height: 100px;
    position: absolute;
    top: 200px;
    left: 30%;
    text-align: center;
    // margin-top: 110px;
    h2 {
      // margin-top: 300px;
      font-size: 30px;
      color: #444198;

    }

    p {
      color: #444198;
      font-size: 15px;
    }
    .demo {
    font-size: 8px;
    margin-top: 10px;
    width: 140px;
    height: 40px;
    background-color: #32c89b;
    text-align: center;
    color: #fff;
    border-radius: 30px;
    border: none;
  }
  }
}

@media(max-width: 1200px) {
  .thanks {
    display: none;
  }
}

@media(max-width: 1200px) {
  .thanksPhone {
    display: block;
  }
}
</style>